<template>
  <div id="Traindetails">
    <Header></Header>
    <Solid></Solid>
    <div class="leftpadding">
      <div class="toparea">
        <div class="crumbs">
          <Goback></Goback>
          <span></span>
        </div>
        <div class="btnbox">
          <a-button class="btn" @click="toscore" type="primary" shape="round">
            成绩查询
          </a-button>
          <a-button class="btn" @click="getreporturl" :disabled="reportdisabled" type="primary" shape="round">
            打印演练报告
          </a-button>
          <!-- printPdf -->
        </div>
      </div>
      <a-row>
        <a-col :span="24">
          <!-- 总计统计 -->
          <Cardtitle msg="考试情况"></Cardtitle>
          <div class="passratebox">
            <div class="passrate theory">
              <div class="titlefount">参与人员</div>
              <div class="title">理论考试成绩<br />合格率</div>
              <div v-if="theroypassrate !== NaN" class="rate">
                {{ theroypassrate + "%" }}
              </div>
              <div v-else class="rate">
                暂无数据
              </div>
              <div class="peoplenum">
                <div v-if="false" class="num">参与人数：{{ theorynum }}</div>
                <div v-if="false" class="num">合格人数：{{ theroypass }}</div>
              </div>
            </div>
            <div class="passrate practical">
              <div class="titlefount">参与人员</div>
              <div class="title">灭火实操演练<br />合格率</div>
              <div v-if="operpassrate !== NaN" class="rate">
                {{ operpassrate + "%" }}
              </div>
              <div v-else class="rate">
                暂无数据
              </div>
              <div class="peoplenum">
                <div v-if="false" class="num">参训人数：{{ numofman }}</div>
                <div v-if="false" class="num">合格人数：{{ operpass }}</div>
              </div>
            </div>
            <!-- <a-tooltip placement="bottomRight">
              <template slot="title">
                <span>点击生成训练报告</span>
              </template> -->
            <div class="passrate creat_report" @click="gochartpage">
              查看报告
            </div>
            <!-- </a-tooltip> -->
          </div>
          <!-- 柱状图和表格统计 -->
          <div class="qualified">
            <h3 class="qualititle">{{ bartitle }}</h3>
            <div ref="departrate" class="statibarchart"></div>
            <!-- 统计表格 -->
            <div class="statitable">
              <a-table :pagination="false" :columns="columns" :data-source="data">
                <template slot="passper" slot-scope="text">
                  <span>{{ text }}%</span>
                </template>
                <template slot="action" slot-scope="text, record">
                  <a v-if="record.departmentId" @click="goreportpage(record)">查看详情</a>
                </template>
              </a-table>
            </div>
          </div>
          <!-- 饼状图统计 -->
          <div class="binechartbox" ref="binechartbox">
            <div ref="sexechart" class="binechart sexechart" v-show="isShowSexechart"></div>
            <div ref="theoryechart" class="binechart theoryechart"></div>
            <div ref="operechart" class="binechart operechart" v-show="isShowOperechart"></div>
            <div ref="outfireechart" class="binechart outfireechart" v-show="isShow"></div>
          </div>
          <!-- <Cardinfo></Cardinfo> -->
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
  import Header from "@/components/Header/Header";
  import Solid from "@/components/Solid/Solid";
  import Goback from "@/components/Goback/Goback";
  import Cardtitle from "@/components/Cardtitle/Cardtitle";
  import Cardinfo from "@/components/Cardinfo/Cardinfo";
  import Axios from "@/Axios";
  import JsPDF from "jspdf";
  import html2Canvas from "html2canvas";
  import infoAction from "@/utils";

  export default {
    name: "Traindetails",
    components: {
      Header,
      Solid,
      Goback,
      // Search,
      Cardtitle,
      Cardinfo,
    },
    data() {
      return {
        isShow: false,
        isShowOperechart: false,
        isShowSexechart: false,
        reportdata: [], //报告数据
        reportdisabled: false,
        url: {
          reportdemo: "/repcomposer/repComposer/list", //获取报告数据
          // operrate: "/statistics/practice", //实操统计
          sexrate: "/statistics/sex", //性别合格率统计
          // theoryrate: "/statistics/theory", //理论成绩统计
          firerate: "/statistics/fire", //灭火统计
          // departrate: "/statistics/department", //部门统计
          pagerate: "/statistics/info", //首页信息
          trainarrange: "/repcomposer/repComposer/report",
        },
        bartitle: "部门合格率统计",
        // universityName: "", //单位名称
        unqualified: "", //实操不及格人数
        operpass: "", //实操及格人数
        operpassrate: "", //实操合格率
        numofman: "", //实操参与人数
        theorynum: "", //理论参与人数
        theroypass: "", //理论合格
        theroypassrate: "", //理论合格率
        theroyunpass: "", //理论不合格
        columns: [
          {
            dataIndex: "departmentName",
            key: "departmentName",
            align: "center",
            title: "部门",
          },
          {
            title: "合格人数",
            align: "center",
            dataIndex: "qualified",
            key: "qualified",
          },
          {
            title: "未合格人数",
            align: "center",
            width: 70,
            key: "unqualified",
            dataIndex: "unqualified",

            // scopedSlots: { customRender: "tags" }
          },
          {
            title: "合格率",
            dataIndex: "passper",
            align: "center",
            key: "passper",
            scopedSlots: { customRender: "passper" },
          },
          {
            title: "操作",
            width: 90,
            align: "center",
            dataIndex: "action",
            key: "action",
            scopedSlots: { customRender: "action" },
          },
        ],
        data: [],
      };
    },
    mounted() {
      // this.numofman = this.$route.query.numofman;
      //
      // console.log(this.$route.query);
      // this.universityName = infoAction.getinfo("universityinfo").universityName;
      this.getbardata(); //部门合格率统计
      // this.drawbin();
    },
    methods: {
      // 请求单位数据
      getbardata() {
        var that = this;
        var xdata = [];
        var ydata = [];
        var tabledata = [];
        if (!this.$route.query.activeCode || !this.$route.query.universityId) {
          return;
        }
        Axios.get(this.url.trainarrange, {
          params: {
            activeCode: this.$route.query.activeCode,
            departmentId: 0,
            universityId: this.$route.query.universityId,
          },
        }).then((res) => {
          if (res.data.code == 200) {
            var records = res.data.result.records;
            this.reportdata = res.data.result.records;
            var newlist = records.map((item, index) => {
              var data = item.visualData || item.originalData;
              data = JSON.parse(data)

              // 整体统计
              // if (item.step == "1") {
              //   this.wholedatahandle(data);
              // }
              // 部门统计
              if (item.step == "2") {
                that.departdrawbar(
                  that.$refs.departrate,
                  that.departdatahandle(data)[0],
                  that.departdatahandle(data)[1],
                  "部门合格统计",
                  "部门"
                );
                that.data = that.tabledatahandle(data);
              }
              // 理论统计
              if (item.step == "3") {
                console.log(data)
                that.theroypassrate = that.passrate(data);
                that.drawbin(
                  that.$refs.theoryechart,
                  that.bindatahandle(data),
                  "理论统计"
                );
              }
              // sexechart theoryechart operechart  outfireechart
              //性别合格率统计
              if (item.step == "4") {
                if (data.length !== 0) {
                  this.isShowSexechart = true
                }
                that.drawbin(
                  that.$refs.sexechart,
                  that.binsexdatahandle(data),
                  "性别合格率统计"
                );
              }
              //灭火统计
              if (item.step == "5") {
                debugger
                if (data.length !== 0) {
                  this.isShowOperechart = true
                }
                that.operpassrate = that.passrate(data);
                that.drawbin(
                  that.$refs.operechart,
                  that.bindatahandle(data),
                  "灭火统计"
                );
              }
              //灭火动作统计
              if (item.step == "6") {
                if (data.length !== 0) {
                  this.isShow = true
                }
                that.drawbar(
                  that.$refs.outfireechart,
                  that.baroutfiredatahandle(data)[0],
                  that.baroutfiredatahandle(data)[1],
                  "灭火动作统计",
                  "动作"
                );
              }
            });
          }
        });
      },
      // 部门统计数据处理
      departdatahandle(data) {
        // console.log(data);
        // let
        var departdata = [];
        var xdata = [];
        var ydata = [];
        data.map((item) => {
          console.log(item)
          var obj = {};
          var passnum; //合格人数
          var nopassnum; //未合格人数
          var passrate; //合格率
          obj.nopass = item.不合格;
          obj.pass = item.合格;
          obj.passrate = ((item.合格 / (item.不合格 + item.合格)) * 100).toFixed(
            1
          );
          obj.departmentName = item.部门;
          obj.departmentId = item.departmentId;
          departdata.push(obj);

          // this.getbindata(item.departmentId);
        });
        departdata.sort(this.sortpassrate);
        departdata.map((item) => {
          xdata.push(item.departmentName);
          ydata.push(item.passrate);
        });

        return [xdata, ydata];
      },
      // 比较合格率
      sortpassrate(item1, item2) {
        return item1.passrate - item2.passrate;
      },
      // 部门柱状图
      departdrawbar(dom, xdata, ydata, title, xName) {
        let that = this;
        // console.log(xdata, ydata, title);
        var mychart = this.$echarts.init(dom);
        mychart.setOption({
          baseOption: {
            title: {
              text: that.$route.query.universityId_dictText + "——" + title,
              left: "50%",
              textAlign: "center",
              textStyle: {
                fontSize: 20,
              },
            },
            color: ["#3398DB"],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
              formatter: "{b}<br/>{a}:{c}%",
              extraCssText: 'white-space: normal; word-break: break-all;'
            },
            grid: {
              left: "3%",
              right: "16%",
              bottom: "3%",
              containLabel: true,
            },
            yAxis: [
              {
                type: "category",
                name: xName,
                data: xdata,
                axisLabel: {
                  interval: 0,
                  // rotate: 50,
                },
                axisTick: {
                  alignWithLabel: true,
                },
              },
            ],
            xAxis: [
              {
                type: "value",
                name: "合格率%",
                nameGap: 0,

                // nameLocation: "center",
                // nameTextStyle. fontWeight
              },
            ],
            series: [
              {
                type: "bar",
                name: xName,
                // formatter: "{a}：{c}",
                barWidth: "30%",
                data: ydata,
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      // rotate:90,
                      // align:'left',
                      // verticalAlign:'middle',
                      // position: "insideBottom",
                      formatter: "{c}%",
                      position: "right",
                      textStyle: {
                        color: "black",
                        fontWeight: "blod",
                        fontSize: "20px",
                      },
                    },
                  },
                },
              },
            ],
          },
          media: [
            {
              query: {
                maxWidth: 500,
              },
              option: {
                title: {
                  text: that.$route.query.universityId_dictText + "——" + title,
                  left: "50%",
                  textAlign: "center",
                  textStyle: {
                    fontSize: 12
                  }
                },
                color: ["#3398DB"],
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    // 坐标轴指示器，坐标轴触发有效
                    type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                  },
                  formatter: "{b}<br/>{a}:{c}%",
                  extraCssText: 'white-space: normal; word-break: break-all;'
                },
                grid: {
                  left: "3%",
                  right: "16%",
                  bottom: "3%",
                  containLabel: true,
                },
                yAxis: [
                  {
                    type: "category",
                    name: xName,
                    data: xdata,
                    axisLabel: {
                      interval: 0,
                      // rotate: 50,
                    },
                    axisTick: {
                      alignWithLabel: true,
                    },
                  },
                ],
                xAxis: [
                  {
                    type: "value",
                    name: "合格率%",
                    nameGap: 0,

                    // nameLocation: "center",
                    // nameTextStyle. fontWeight
                  },
                ],
                series: [
                  {
                    type: "bar",
                    name: xName,
                    // formatter: "{a}：{c}",
                    barWidth: "30%",
                    data: ydata,
                    itemStyle: {
                      normal: {
                        label: {
                          show: true,
                          // rotate:90,
                          // align:'left',
                          // verticalAlign:'middle',
                          // position: "insideBottom",
                          formatter: "{c}%",
                          position: "right",
                          textStyle: {
                            color: "black",
                            fontWeight: "blod",
                            fontSize: "20px",
                          },
                        },
                      },
                    },
                  },
                ],
              }
            }
          ]







        });
      },
      // 柱状图
      drawbar(dom, xdata, ydata, title, xName) {
        // console.log(xdata, ydata, title);
        var mychart = this.$echarts.init(dom);
        mychart.setOption({
          title: {
            text: title,
            left: "50%",
            textAlign: "center",
          },
          color: ["#3398DB"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: "{b}<br/>{a}:{c}%",
          },
          grid: {
            left: "50",
            right: "50",
            bottom: "50",
            containLabel: true,
          },
          yAxis: [
            {
              type: "value",
              name: "合格率%",
              // yAxis.nameTextStyle. verticalAlign
            },
          ],
          xAxis: [
            {
              type: "category",
              name: xName,
              // nameLocation:'start',
              data: xdata,
              axisLabel: {
                interval: 0,
                rotate: 50,
              },
              // nameRotate:"90",
              // axisLabel:{
              // formatter:function(value){
              //       return value.split("").join("\n");
              // }
              // },
              nameGap: 0,
              axisTick: {
                alignWithLabel: true,
              },
              // nameLocation: "center",
              // nameTextStyle. fontWeight
            },
          ],
          series: [
            {
              name: "合格率",
              type: "bar",
              // formatter: "{a}：{c}",
              barWidth: "30%",
              data: ydata,
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    // rotate:90,
                    // align:'left',
                    // verticalAlign:'middle',
                    // position: "insideBottom",
                    formatter: "{c}%",
                    position: "top",
                    textStyle: {
                      color: "red ",
                      fontWeight: "blod",
                      fontSize: "20px",
                    },
                  },
                },
              },
            },
          ],
        });
      },
      // 饼图
      drawbin(dom, data, bintitle) {
        var mychart = this.$echarts.init(dom);
        // mychart.resize({width: 622, height: 310 });
        if (window.innerWidth>500) {
          mychart.resize({width: 622, height: 310 });
        }
        mychart.setOption({
          baseOption: {
            color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
            title: {
              text: bintitle,
              left: "center",
            },
            grid: {
              top: 10,
              bottom: 10,
              left: 10,
              right: 10,
            },
            tooltip: {
              trigger: "item",
              formatter: "{b} : {c} ({d}%)",
            },
            legend: {
              // orient: 'vertical',
              // top: 'middle',
              bottom: 10,
              left: "center",
              selectedMode: false, //取消图例上的点击事件
            },
            series: [
              {
                type: "pie",
                radius: "65%",
                center: ["50%", "50%"],
                selectedMode: "single",
                data: data,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      formatter: "{b} : {c} ({d}%)",
                    },
                    lableLine: { show: true },
                  },
                },
              },
            ],
          },
          media: [
            {
              query: {
                maxWidth: 500,
              },
              option: {
                title: {
                  text: bintitle,
                  left: "center",
                },
                grid: {
                  top: 10,
                  bottom: 10,
                  left: 10,
                  right: 10,
                },
                tooltip: {
                  trigger: "item",
                  formatter: "{b} : {c} ({d}%)",
                },
                legend: {
                  // orient: 'vertical',
                  // top: 'middle',
                  bottom: 10,
                  left: "center",
                  selectedMode: false, //取消图例上的点击事件
                },
                series: [
                  {
                    type: "pie",
                    radius: "25%",
                    center: ["50%", "50%"],
                    selectedMode: "single",
                    data: data,
                    emphasis: {
                      itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                      },
                    },
                    itemStyle: {
                      normal: {
                        label: {
                          show: true,
                          formatter: "{b} : {c} ({d}%)",
                        },
                        lableLine: { show: true },
                      },
                    },
                  },
                ],
              },
            },
          ],
        });
      },
      toscore() {
        window.location.href = window.network["domianBase"] + '/user/searchresult'
        // this.$router.push("/searchresult");
      },
      goreportpage(departdata) {
        // console.log(this.$route.query);
        var query = this.$route.query;
        query.departmentId = departdata.departmentId;
        query.departmentName = departdata.departmentName;
        this.$router.push({
          path: "/Reportpage",
          query: query,
        });
      },
      gochartpage() {
        console.log(this.$route.query);
        // return;
        var query = this.$route.query;
        // query.departmentId = departdata.departmentId;
        // query.departmentName = departdata.departmentName;
        this.$router.push({
          path: "/Chartpage",
          query: query,
        });
      },
      // 获取训练报告url
      getreporturl() {
        Axios.get("/pdframework/yhaPdfFramework/list", {
          params: {
            universityId: this.$route.query.universityId,
            sysOrgCode: this.$route.query.activeCode,
          },
        }).then((res) => {
          if (res.data.code == 200) {
            var records = res.data.result.records;
            console.log("records", records);
            // console.log(
            //   window.network["domianURL"] + "/" + records[0].conclusionRemarkUrl
            // );
            if (records[0] && records[0].conclusionRemarkUrl) {
              window.location.href =
                window.network["domianURL"] +
                "/" +
                records[0].conclusionRemarkUrl;
            } else {
              this.$message.info("本次活动暂无活动报告，请联系管理员~");
            }
          }
        });
      },
      // 打印
      // x/94= 592.28/841.89*94
      printPdf() {
        var that = this;
        that.reportdisabled = true;
        setTimeout(() => {
          that.reportdisabled = false;
        }, 5000);
        var a4Width = 592.28;
        var a4Height = 841.89;
        var childrenArr = [this.$refs.departrate, this.$refs.binechartbox];
        var pdf = new JsPDF("l", "pt", [a4Height, a4Width]);
        that.itemEleToPdf(childrenArr, 0, pdf);
      },
      itemEleToPdf(eleList, index, pdf) {
        var that = this;
        that.$message.loading(
          "生成中报告,请稍后……" + (index + 1) + "/" + eleList.length,
          1
        );
        html2Canvas(eleList[index]).then(function (canvas) {
          var contentWidth = canvas.width;
          var contentHeight = canvas.height;
          var contentBackgroundColor = "white";
          // a4宽度  px
          var a4Width = 592.28;
          var a4Height = 841.89;
          //一页pdf显示html页面生成的canvas高度;
          var pageHeight = (contentWidth / a4Width) * a4Height;
          //未生成pdf的html页面高度
          var leftHeight = contentHeight;
          //页面偏移
          //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高

          var imgHeight = (a4Width / contentWidth) * contentHeight;

          var pdfHeight = (a4Width / contentWidth) * contentHeight;
          pdf.addImage(canvas, "JPEG", 0, 0, a4Height, a4Width);
          if (index >= eleList.length - 1) {
            pdf.save(
              that.$route.query.universityId_dictText + "——消防演练报告.pdf"
            );
            return;
            // 完成
            // pdf.save('消防演练实施报告' + '.pdf')
            let formData = new FormData();
            var blob = pdf.output("blob");
            // fromdata参数
            formData.append(
              "file",
              blob,
              "消防演练实施报告" + new Date().getTime() + ".pdf"
            );
            formData.append("biz", "temp");
            // 上传
            Axios.post("/sys/common/upload", formData, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }).then((res) => {
              if (res.data.success) {
                Axios.put("/pdframework/yhaPdfFramework/editOne", {
                  conclusionRemarkUrl: res.data.message,
                  sysOrgCode: that.activeCode,
                  universityId: that.universityId,
                }).then((res) => {
                  if (res.data.code == 200) {
                    that.$message.success(res.data.message);
                  } else {
                    that.$message.info(res.data.message);
                  }
                  that.close();
                });
              }
              that.close();
              that.isloading = false;
            });
            return;
          } else {
            // 继续
            index++;
            pdf.addPage();
            that.itemEleToPdf(eleList, index, pdf);
          }
        });
      },
      // 合格率
      passrate(data) {
        console.log(data[0].rateMap)
        // data
        var allstu = data[0].rateMap.total
        var passstu = data[0].rateMap.passCount;
        var nopass = data[0].rateMap.failCount;
        var passrate = ((passstu / allstu) * 100).toFixed(2);
        console.log("合格", passstu);
        console.log("不合格", nopass);
        console.log("合格率", passrate);
        return passrate;
      },
      // 性别饼图数据处理
      binsexdatahandle(data) {
        var arr = [];
        data.map((item) => {
          var obj = {};
          obj.value = item.合格;
          obj.name = item.性别;
          arr.push(obj);
        });
        return arr;
      },
      // 部门表格数据处理
      tabledatahandle(data) {
        var result = [];
        data.map((item) => {
          var obj = {};
          // departmentName qualified unqualified passper departmentId
          obj.departmentName = item.部门;
          obj.departmentId = item.departmentId;
          obj.unqualified = parseInt(item.不合格);
          obj.qualified = parseInt(item.合格);
          obj.passper = (
            (obj.qualified / (obj.unqualified + obj.qualified)) *
            100
          ).toFixed(1);
          result.push(obj);
        });
        result.sort(this.sorttabledata);
        // console.log("***************",result);
        return result;
      },
      sorttabledata(item1, item2) {
        return item2.passper - item1.passper;
      },
      // 灭火动作数据处理
      outfiredatahandle(data) {
        var xdata = [];
        var ydata = [];
        data.map((item) => {
          // obj = {}
          xdata.push(item._id);
          ydata.push((item.per * 100).toFixed(1));
        });
        return [xdata, ydata];
      },
      // 灭火动作柱状图数据处理
      baroutfiredatahandle(data) {
        var xdata = [];
        var ydata = [];
        xdata.push();
        data.map((item) => {
          xdata.push(item._id);
          ydata.push((item.per * 100).toFixed(1));
        });
        return [xdata, ydata];
      },
      // 其他饼图数据处理
      bindatahandle(data) {
        console.log(data)
        if (data[0].rateMap) {
          delete data[0].rateMap
        }
        var arr = [];
        for (var key in data[0]) {
          var obj = {};
          obj.value = data[0][key];
          obj.name = key;
          arr.push(obj);
        }
        return arr;
      },
    },
    filters: {
      conversion(num) {
        // console.log(parseInt(num).toFixed(2) + "%");
        return parseInt(num).toFixed(1) + "%";
      },
    },
  };
</script>

<style scoped>
  .leftpadding {
    /* padding-left: 3vw; */
    box-sizing: border-box;
    padding: 0 3vw;
  }

  .toparea {
    height: 8vh;
    /* border: 1px solid red; */
    border-bottom: 1px solid rosybrown;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 3vh;
  }

  .btn {
    padding: 0 2vw;
    margin-right: 2vw;
    box-shadow: 0px 4px 13px 0px rgba(143, 94, 30, 0.5);
  }

  .passratebox {
    display: flex;
    justify-content: space-around;
    text-align: center;
    box-shadow: 1px 4px 13px 0px rgba(88, 87, 86, 0.29);
    border-radius: 10px;
    padding: 40px 0;
    margin-bottom: 2vh;
  }

  .passrate {
    display: flexbox;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    width: 30%;
    box-sizing: border-box;
    padding: 30px 0;
    border-radius: 8px;
  }

  .theory {
    /* background-color: #f9deb6; */
    background-image: url("./../../assets/theper_bg.png");
    background-size: 100% 100%;
  }

  .practical {
    /* background-color: #fbe0dc; */
    background-image: url("./../../assets/operper_bg.png");
    background-size: 100% 100%;
  }

  @media screen and (max-width: 768px) {
    .titlefount {
      font-size: 14px;
      /* font-weight: bold; */
      color: red;
    }

    .title {
      font-size: 14px;
      font-weight: bold;
      margin-top: 10px;
      /* line-height: 30px; */
    }

    .rate {
      font-size: 14px;
      font-weight: bold;
      color: red;
      line-height: 50px;
    }

    .peoplenum {
      display: flex;
      flex-direction: row;
      /* width: 40%; */
      justify-content: center;
      align-items: center;
      line-height: 60px;
    }

    .num {
      margin-right: 1vw;
    }

    .creat_report {
      /* width: 10%; */
      /* background-color: #f9deb6; */
      font-size: 14px;
      font-weight: bold;
      line-height: 110px;
      color: red;
      cursor: pointer;
      background-image: url("./../../assets/theper_bg.png");
      background-size: 100% 100%;
    }
  }

  @media screen and (min-width: 768px) {
    .titlefount {
      font-size: 18px;
      /* font-weight: bold; */
      color: red;
    }

    .title {
      font-size: 18px;
      font-weight: bold;
      margin-top: 10px;
      /* line-height: 30px; */
    }

    .rate {
      font-size: 18px;
      font-weight: bold;
      color: red;
      line-height: 50px;
    }

    .peoplenum {
      display: flex;
      flex-direction: row;
      /* width: 40%; */
      justify-content: center;
      align-items: center;
      line-height: 60px;
    }

    .num {
      margin-right: 1vw;
    }

    .creat_report {
      /* width: 10%; */
      /* background-color: #f9deb6; */
      font-size: 18px;
      font-weight: bold;
      line-height: 110px;
      color: red;
      cursor: pointer;
      background-image: url("./../../assets/theper_bg.png");
      background-size: 100% 100%;
    }
  }

  .qualititle {
    font-weight: bold;
    font-size: 20px;
    line-height: 60px;
  }

  .qualified {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    box-shadow: 1px 4px 13px 0px rgba(88, 87, 86, 0.29);
    margin-bottom: 30px;
  }

  @media screen and (min-width: 768px) {
    .statibarchart {
      width: 75.2vw;
      height: 52.9vw;
      border: 1px solid black;
      box-sizing: border-box;
      padding-top: 50px;
      /* padding: 30px; */
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 768px) {
    .statibarchart {
      width: 90vw;
      height: 100vw;
      border: 1px solid black;
      box-sizing: border-box;
      padding-top: 50px;
      /* padding: 30px; */
      margin-bottom: 30px;
    }
  }

  @media screen and (min-width: 768px) {
    .statitable {
      width: 81%;
      border: 1px solid black;
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 768px) {
    .statitable {
      width: 95%;
      border: 1px solid black;
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 768px) {
    .statitable>>>.ant-table-thead>tr>th {
      padding: 16px 8px !important;
    }

    .statitable>>>.ant-table-tbody>tr>td {
      padding: 16px 8px !important;
    }
  }

  .binechartbox {
    width: 94vw;
    box-shadow: 1px 4px 13px 0px rgba(88, 87, 86, 0.29);
    height: 66.13vw;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: center;
    box-sizing: border-box;
    padding: 60px;
  }

  .binechart {
    width: 45%;
    height: 400px;
  }
  @media screen and (max-width: 768px) {
    .passrate {
      width: 40%;
    }

    .peoplenum {
      display: block;
      line-height: 5vh;
    }

    .binechartbox {
      display: flex;
      flex-direction: column;
      height: auto;
      padding: 3vh 0vw;
    }

    .binechart {
      border-bottom: 1px solid gray;
      box-sizing: border-box;
      padding-top: 14vw;
      width: 90vw;
      height: 65vh;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Traindetails/Traindetails.vue